const EN = {
    "1": "Simplified Chinese",
    "2": "Traditional Chinese",
    "3": "English",
    "4": "Login",
    "5": "ALL",
    "6": "News",
    "7": "Competition",
    "8": "Activity",
    "9": "Information",
    "10": "New Shop",
    "11": "News List",
    "12": "Shop List",
    "13": "Shop Activities",
    "14": "Product Display",
    "15": "Social Media",
    "16": "Recent results",
    "17": "Change items",
    "18": "Exit",
    "19": "Confirm",
    "20": "My Page",
    "21": "Overall Data",
    "22": "Game Information",
    "23": "Home Shop",
    "24": "Friends chat",
    "25": "Other Settings",
    "26": "Account",
    "27": "Password",
    "28": "Forgot account number",
    "29": "Forgot password",
    "30": "Register",
    "31": "Country/Region",
    "32": "Language",
    "33": "Member Information",
    "34": "ID",
    "35": "Card Number",
    "36": "Password",
    "37": "Confirm Password",
    "38": "Nickname",
    "39": "Email",
    "40": "Please enter 6-20 English letters or numbers!",
    "41": "The password must consist of 6-20 letters!",
    "42": "Verifiy Adarts account through email address!",
    "43": "Necessary game information",
    "44": "Name",
    "45": "Gender",
    "46": "SMS",
    "47": "Date of Birth",
    "48": "Mobile Phone Number",
    "49": "To participate in various tournaments held by Adarts, the following information is required.",
    "50": "Enter the following information and confirmation email to accept the items that you can use immediately.",
    "51": "Agree to accept the message",
    "52": "Reject to accept the message",
    "53": "Male",
    "54": "Female",
    "55": "Mail Settings",
    "56": "Clicking [Register] means that you have agreed to Adarts' terms of use, and have read and understood the personal data policy including the use of cookies",
    "57": "Register",
    "58": "Forgot account ID",
    "59": "Send verification code",
    "60": "Adarts account password",
    "61": "Adarts account email",
    "62": "Adarts account ID",
    "63": "Please enter the correct format!",
    "64": "Last 30 game results",
    "65": "Award Data",
    "66": "Chat Content",
    "67": "Friends List",
    "68": "Add New Friend",
    "69": "Adarts Card Settings",
    "70": "Account Information Setting",
    "71": "Award Message Setting",
    "72": "Items setting",
    "73": "Password Setting",
    "74": "Bull Quantity",
    "75": "01 total number of games/win rate",
    "76": "Cricket total number of games/win rate",
    "77": "Total number of games/winning rate",
    "78": "Count Up average score",
    "79": "Count Up the highest score",
    "80": "Highest Score",
    "81": "Bull hit rate",
    "82": "S-Bull hit rate",
    "83": "D-Bull hit rate",
    "84": "Triple hit rate",
    "85": "01 Fastest darts finish ",
    "86": "Please enter the username!",
    "87": "Please enter the password!",
    "88": "Verification code",
    "89": "enter the verification code!",
    "90": "Please enter the email address!",
    "91": "Please enter the account number!",
    "92": "All",
    "93": "Friend",
    "94": "Close friends",
    "95": "Operation",
    "96": "Card Copy",
    "97": "Delete",
    "98": "Add card",
    "99": "(Country/Region)/Language",
    "100": "Card registration date",
    "101": "Set theme",
    "102": "Image",
    "103": "If you have registered various types of AWARD messages on an Adarts card, it will be displayed at each AWARD during the game when you use the card",
    "104": "AWARD information",
    "105": "Information",
    "106": "AWARD",
    "107": "You can change your password on this page. The new password will be used for your card ID and account ID",
    "108": 'Old password',
    "109": 'New password',
    "110": 'Passwords do not match! ',
    "111": 'Adarts shop homepage',
    "112": 'Adarts search shop',
    "113": 'Theme stop has been set up',
    "114": 'New Shop',
    "115": 'Select area',
    "116": "Today's game information",
    "117": 'Recommendation',
    "118": 'Player list',
    "119": 'Rank',
    "120": 'Search Shop',
    "121": 'Customer Service',
    "122": 'Players played against within 7 days',
    "123": 'New',
    "124": 'Accept',
    "125": 'Copy successful',
    "126": 'Confirm delete? ',
    "127": 'Cancel',
    "128": 'This month',
    "129": 'Number of times',
    "130": 'Please login and check my page! ',
    "131": 'Verification method',
    "132": 'No Data',
    "133": 'Countdown:',
    "134": 'Please enter a new password',
    "135": 'My Page',
    "136": 'Item Shop',
    "137": 'Adarts shop',
    "138": 'Mission Reward',
    "139": 'Introduction to players',
    "140": 'Dart specifications',
    "141": 'Tournament results',
    "142": 'Player videos',
    "143": 'Related products',
    "144": 'Set as the main card',
    "145": 'A1 machine',
    "146": 'W1 machine',
    "147": 'View map',
    "148": 'Theme style',
    "149": 'Business hours',
    "150": 'Resting day',
    "151": 'Address',
    "152": 'Traffic information',
    "153": 'Budget',
    "154": 'Theme',
    "155": 'Service',
    "156": 'URL',
    "157": 'Tournament ranking',
    "158": 'Items Shop',
    "159": 'Darts Column',
    "160": 'Message from shop',
    "161": "Player's Card",
    "162": 'Home page',
    "163": 'My Item',
    "164": 'Purchase Item',
    "165": 'Search Item Store',
    "166": 'My Settings',
    "167": 'My item list',
    "168": 'Exchange item',
    "169": 'Item recommendation',
    "170": 'New Item',
    "171": 'Item Ranking',
    "172": 'Exchange items for gold',
    "173": 'Choose Template',
    "174": 'Save Settings',
    "175": 'Style Settings',
    "176": 'Items in use',
    "177": 'Award Settings',
    "178": 'Renew',
    "179": 'Selected Items',
    "180": "After the item's user period time is extended, you will not be able to cancel it!",
    "181": 'Number of gold exchanged',
    "182": 'Current number of gold',
    "183": 'Total number of gold',
    "184": 'Item details',
    "185": 'Gold owned',
    "186": 'Give present',
    "187": 'Request a gift',
    "188": 'Confirm to buy',
    "189": 'Buy and start using',
    "190": 'Buy',
    "191": 'What is GOLD?',
    "192": 'Ways to get GOLD',
    "193": 'What is Item Shop?',
    "194": 'Sort Gold Item & Item Type',
    "195": 'Purchase Item & Custom(Item settings and cancellation)',
    "196": 'Recent opponents',
    "197": 'Choose',
    "198": 'Last play time (days)',
    "199": 'Friend request sent',
    "200": 'Award Ranking',
    "201": 'Ongoing',
    "202": 'Ended',
    "203": 'Host Shop',
    "204": 'Activity Date',
    "205": 'Dart Machine',
    "206": 'How to participate',
    "207": 'Contact Information',
    "208": 'Tournament Time',
    "209": 'Request Present',
    "210": 'Activity Description',
    "211": 'How to participate',
    "212": 'Registration Fee',
    "213": 'Entry Fee',
    "214": 'Reward',
    "215": 'Others',
    "216": 'Not yet started',
    "217": 'Present Box',
    "218": 'Received Present',
    "219": 'Received Present Request',
    "220": 'Gift friend',
    "221": 'Time of gift',
    "222": 'Accept All',
    "223": 'Sort by purchase time',
    "224": 'Sort the order of purchase time',
    "225": '※ Item The date below is the date of purchase',
    "226": 'Deducted gold',
    "227": 'Store up to 10 templates',
    "228": 'If you want to save another template, please delete unnecessary templates in the template selection',
    "229": "Please enter template's name",
    "230": "Don't use template",
    "231": 'Agree',
    "232": 'Decline',
    "233": 'Request Time',
    "234": 'Shop Type',
    "235": 'Highest winning streak',
    "236": 'Japanese',
    "237": 'Please enter a new card number',
    "238": ' Please use a brand new card for the card copy function, after card copy, the original card cannot be used ',
    "239": 'Send',
    "240": 'Forgot account name or password',
};
export default EN;